import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";

function GenerarCodigos() {
    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [codigoGenerado, setCodigoGenerado] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const apiFetch = useApiFetch();

    const handleGenerar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        // Valida que exista dato
        if (!idTecnico) {
            setError("Debe ingresar el número de empleado.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        // Validación de formato (exactamente 7 dígitos)
        if (!/^\d{7}$/.test(idTecnico)) {
            setError("El ID técnico debe contener exactamente 7 dígitos.");
            setTimeout(() => setError(""), 3000);
            return;
        }

        setLoading(true);

        try {

            const data = await apiFetch("generar_codigos.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_tecnico: idTecnico, id_permiso: 10 })
            }, logout);

            //console.log("Respuesta del backend generar_codigos.php // Mensaje desde GenerarCodigos.jsx:", data);  // Línea de prueba

            if (data.status === "ok" && data.codigo) {
                setCodigoGenerado(data.codigo);
                setSuccess("\u2705 Código generado correctamente.");
            } else {
                setError(data.message || "Error al generar código.");
            }
        } catch {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    const handleContinuar = () => {
        setModuloActual("Control");
        setSubModuloActual(null);
    };

    // Limpiar mensajes automáticamente después de 2 segundos
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [error, success]);

    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}

            {!codigoGenerado && (
                <form onSubmit={handleGenerar}>

                    <InputGenerico
                        value={idTecnico}
                        setValue={setIdTecnico}
                        label="Código para el empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos numéricos"
                    />

                    <div className="form-buttons">
                        <button type="submit" disabled={loading}>
                            {loading ? "Generando..." : "Generar código"}
                        </button>
                    </div>
                </form>
            )}

            {codigoGenerado && (
                <div>
                    <p>El código generado para el técnico <strong>{idTecnico}</strong> es:</p>
                    <h2>{codigoGenerado}</h2>
                    {success && <div className="success">{success}</div>}
                    {error && <div className="error">{error}</div>}
                    <div className="form-buttons">
                        <button onClick={handleContinuar}>Continuar</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default GenerarCodigos;